export default function (scheduler) {
	function parseHashParameters() {
		const parameters = {};
		const raw = (document.location.hash || "").replace("#", "");
		if (!raw) {
			return parameters;
		}

		const pairs = raw.split(",");
		for (let i = 0; i < pairs.length; i++) {
			const parts = pairs[i].split("=");
			if (parts.length === 2) {
				parameters[parts[0]] = parts[1];
			}
		}
		return parameters;
	}

	// Keep backward-compatible API because cookie plugin checks it
	scheduler._get_url_nav = function () {
		return parseHashParameters();
	};

	const dateToString = scheduler.date.date_to_str("%Y-%m-%d");

	const originalGetInitialState = scheduler._getInitialState;

	scheduler._getInitialState = function (provided) {
		const baseState = originalGetInitialState.call(this, provided);

		const url = scheduler._get_url_nav ? scheduler._get_url_nav() : null;
		if (!url) {
			return baseState;
		}

		const nextState = {
			date: baseState.date,
			mode: baseState.mode
		};

		if (url.date) {
			const stringToDate = scheduler.date.str_to_date("%Y-%m-%d");
			try {
				const parsed = stringToDate(url.date);
				if (!isNaN(+parsed)) {
					nextState.date = parsed;
				}
			} catch (e) {
				// ignore invalid date
			}
		}

		if (url.mode) {
			try {
				if (this.isViewExists(url.mode)) {
					nextState.mode = url.mode;
				}
			} catch (e) {
				// ignore
			}
		}

		return nextState;
	};


	function updateHashFromState(optionalSelectedEventId) {
		const currentDate = scheduler._date || scheduler.getState().date;
		const currentMode = scheduler.getState().mode;

		const values = [
			"date=" + dateToString(currentDate),
			"mode=" + currentMode
		];

		if (optionalSelectedEventId) {
			values.push("event=" + optionalSelectedEventId);
		}

		document.location.hash = "#" + values.join(",");
	}

	function showEventWhenPossible(eventId) {
		if (!eventId) {
			return;
		}

		const tryShowNow = function () {
			if (scheduler.$destroyed) {
				return;
			}
			if (scheduler.getEvent(eventId)) {
				scheduler.showEvent(eventId);
				return true;
			}
			return false;
		};

		if (tryShowNow()) {
			return;
		}

		const onLoadedId = scheduler.attachEvent("onParse", function () {
			tryShowNow();
			scheduler.detachEvent(onLoadedId);
			return true;
		});
	}

	// Keep the "event=" part until it's actually displayed, then drop it (legacy behavior)
	let pendingSelectedEventId = null;

	scheduler.attachEvent("onSchedulerReady", function () {
		const initialState = scheduler._get_url_nav();

		if (initialState.event) {
			pendingSelectedEventId = initialState.event;
			showEventWhenPossible(initialState.event);
		}

		updateHashFromState(pendingSelectedEventId);
		return true;
	});

	scheduler.attachEvent("onAfterEventDisplay", function () {
		pendingSelectedEventId = null;
		updateHashFromState(null);
		return true;
	});

	scheduler.attachEvent("onViewChange", function () {
		updateHashFromState(pendingSelectedEventId);
		return true;
	});
}